import { productDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { css } from "styled-components";

// EC-27 : Sub Task - 553 Cart Page 
// Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments.
productDescriptionStyles.productDetailLink = {
	css: css`
		span{
			font-size: 14px;
			font-family: inherit;
		}
    `,
}

//End: Refactored dynamic CSS from CMS to code for consistent behavior across environments.